// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host(app-view-application-details-zcams) {
  height: calc(100vh - 288px);
  width: 100%;
  overflow-y: hidden;
  overflow-x: hidden;
}

.saverow {
  height: 44px;
  min-height: 44px !important;
  align-items: center;
}

.content-area {
  height: calc(100vh - 288px);
  margin-bottom: 1%;
  margin-right: 36.55px;
  overflow-y: hidden;
}

.description-text {
  resize: none;
  border: none Transparent;
  outline: none;
  height: 50px;
  color: #2C2B2D;
  font-family: Inter;
  font-style: normal;
  font-size: 13px;
  width: 100%;
}

.detail-form {
  height: 100%;
}

.remove-button {
  margin-left: 10px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
